module.exports = "data:image/webp;base64,UklGRhQBAABXRUJQVlA4IAgBAADwBQCdASoZABkAPpE+mkmloyIhKAqosBIJZzuF4AL3psgxfrOlSuJ8xCq2vf4C7Y6QDp2CmjxJAAD+74Hw89LHQrTy6wkZDn4IqlM7yyFxngqOE02Hajb9qgWpn1AxZmFx1q+2V1vzbuKBieA/79WewwmCMWVjWg/uYBWvjiZy7lqM/+zLHnBXJywSPe/jFPfQJ/C07DV1cppqvU0XhtJm4SitGP2/BHiJ8RrQAf5dT5SIdF1hD0ZiQbEtw0GHdPdhJd0EwSm1SD4xsobIRqqAdB5cytwde1P4udRTn/gnA4li4WEISRrJQS4mypy3zAIl0Kc9DNwpYEtY7gcVG9iHCVk95CB1wAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/medium_blue_sw.webp
// module id = I+H4
// module chunks = 14